import types from 'redux/types';

const getRepliesServlet = (token) => {
  return {
    type: types.REQUEST_API_AUTO_REPLIES_SERVLET,
    token,
  };
};

const changeStatusRepliesServlet = (data) => {
  return {
    type: types.REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS,
    ...data,
  };
};

const clearRepliesServlet = () => {
  return {
    type: types.REQUEST_CLEAR_AUTO_REPLIES_SERVLET,
  };
};

export default {
  getRepliesServlet,
  clearRepliesServlet,
  changeStatusRepliesServlet,
};
